<app-alert></app-alert>

<div class="row mt-2">
    <div class="form-group col mb-n1">
        <h1>Discount Period</h1>
    </div>
</div>

<div class="card mb-3 mt-2">
    <div class="card-body bg-light p-3">Set Discount Period From To</div>
</div>

<form [formGroup]="periodDiscountForm" (ngSubmit)="onSubmit()">
    <div class="form-group hidden">
        <div class="input-group">
            <input
                name="datepicker"
                class="form-control"
                ngbDatepicker
                #datepicker="ngbDatepicker"
                [autoClose]="'outside'"
                (dateSelect)="onDateSelection($event)"
                [displayMonths]="2"
                [dayTemplate]="t"
                outsideDays="hidden"
                [startDate]="fromDate!"
                tabindex="-1"
                container="body"
            />
            <ng-template #t let-date let-focused="focused">
                <span
                    class="custom-day"
                    [class.focused]="focused"
                    [class.range]="isRange(date)"
                    [class.faded]="isHovered(date) || isInside(date)"
                    (mouseenter)="hoveredDate = date"
                    (mouseleave)="hoveredDate = null"
                >
                    {{ date.day }}
                </span>
            </ng-template>
        </div>
    </div>
    <div class="form-group">
        <label for="from">From</label>
        <input
            id="from"
            class="form-control w-md-25 input-datepicker-icon"
            #dpFromDate
            placeholder="yyyy/dd/mm"
            name="dpFromDate"
            [value]="formatter.format(fromDate)"
            (input)="fromDate = validateInput(fromDate, dpFromDate.value)"
            (click)="datepicker.toggle()"
        />
    </div>
    <div class="form-group">
        <label for="to">To</label>
        <input
            id="to"
            class="form-control w-md-25 input-datepicker-icon"
            #dpToDate
            placeholder="yyyy/dd/mm"
            name="dpToDate"
            [value]="formatter.format(toDate)"
            (input)="toDate = validateInput(toDate, dpToDate.value)"
            (click)="datepicker.toggle()"
        />
    </div>
    <div class="form-group">
        <label for="branchName">Discount Value</label>
        <div class="input-group mb-3 w-md-25">
            <input type="text" class="form-control" digitOnly [decimal]="true" formControlName="discountPeriodValue" />
            <div class="input-group-append">
                <span class="input-group-text">%</span>
            </div>
        </div>
    </div>
    <div class="form-group">
        <button class="btn btn-primary btn-sm" type="submit" [disabled]="formBusy">Save</button>
    </div>
</form>
